import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { exclusive: Array }

  connect() {
    this.select = this.element.tagName === "SELECT" ? this.element : this.element.querySelector("select")
    if (!this.select) return
    this.$select = window.jQuery ? window.jQuery(this.select) : null
    this.apply()
    if (this.$select) {
      this.$select.on("change.role-exclusivity", () => this.apply())
    } else {
      this.select.addEventListener("change", () => this.apply())
    }
  }

  disconnect() {
    if (this.$select) this.$select.off("change.role-exclusivity")
  }

  apply() {
    const selected = Array.from(this.select.selectedOptions).map(o => o.text.trim().toLowerCase())
    const exclusiveNames = (this.exclusiveValue || []).map(n => n.toLowerCase())
    const hasExclusive = selected.some(name => exclusiveNames.includes(name))
    const hasOther = selected.some(name => !exclusiveNames.includes(name))

    Array.from(this.select.options).forEach(option => {
      const name = option.text.trim().toLowerCase()
      const isExclusive = exclusiveNames.includes(name)
      if (option.selected) {
        option.disabled = false
        return
      }
      if (hasExclusive && !isExclusive) {
        option.disabled = true
      } else if (hasOther && isExclusive) {
        option.disabled = true
      } else {
        option.disabled = false
      }
    })

    if (this.$select) this.$select.trigger("change.select2")
  }
}
